import * as Styled from './FeedbackModalStyles';

interface AttitudeSelectProps{
  selected: number | null,
  onChange: Function,
}

const AttitudeSelect = ({ selected, onChange }: AttitudeSelectProps) => {

  const onSelect = (value:number) => () => {
    onChange(value);
  }

  return (
    <div style={{ marginBottom: 10 }}>
      <Styled.StyledFormLabel>
        Rate your experience with Trova
      </Styled.StyledFormLabel>
      <Styled.Container className="Wrapper">
        <Styled.AttitudeButton
          active={selected === -2}
          onClick={onSelect(-2)}
        >
          <span>
            &#128553;
          </span>
        </Styled.AttitudeButton>
        <Styled.AttitudeButton
          active={selected === -1}
          onClick={onSelect(-1)}
        >
          <span>
            &#128543;
          </span>
        </Styled.AttitudeButton>
        <Styled.AttitudeButton
          active={selected === 0}
          onClick={onSelect(0)}
        >
          <span>
            &#128528;
          </span>
        </Styled.AttitudeButton>
        <Styled.AttitudeButton
          active={selected === 1}
          onClick={onSelect(1)}
        >
          <span>
            &#128578;
          </span>
        </Styled.AttitudeButton>
        <Styled.AttitudeButton
          active={selected === 2}
          onClick={onSelect(2)}
        >
          <span>
            &#128512;
          </span>
        </Styled.AttitudeButton>
      </Styled.Container>
    </div>
  )
}

export default AttitudeSelect;